import { render, staticRenderFns } from "./storeManage.vue?vue&type=template&id=4c9ee28b&scoped=true"
import script from "./storeManage.vue?vue&type=script&lang=js"
export * from "./storeManage.vue?vue&type=script&lang=js"
import style0 from "./storeManage.vue?vue&type=style&index=0&id=4c9ee28b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9ee28b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9ee28b')) {
      api.createRecord('4c9ee28b', component.options)
    } else {
      api.reload('4c9ee28b', component.options)
    }
    module.hot.accept("./storeManage.vue?vue&type=template&id=4c9ee28b&scoped=true", function () {
      api.rerender('4c9ee28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/group/storeManage.vue"
export default component.exports